import { disclaimerText, footerLinks } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-950 text-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-12 md:gap-6">
          <div className="col-span-2 md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg font-bold text-background-50">
                黑
              </span>
              <span className="flex flex-col leading-tight">
                <span className="font-heading text-lg font-bold text-background-50">
                  黑料曝光
                </span>
                <span className="text-[10px] tracking-[0.28em] text-secondary-400">
                  HOT EXPOSE
                </span>
              </span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-secondary-300">
              把分散的聊天记录、录音证据、内部截图与知情人透露，按完整时间线逐层归档，
              让你看清事件背后的真实脉络。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <span className="rounded-full bg-secondary-900 px-3 py-1 text-xs text-secondary-300">
                收录材料 536 份
              </span>
              <span className="rounded-full bg-secondary-900 px-3 py-1 text-xs text-secondary-300">
                关键节点 128 个
              </span>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title} className="md:col-span-2">
              <h4 className="font-heading text-sm font-semibold text-background-50">
                {group.title}
              </h4>
              <ul className="mt-4 space-y-3">
                {group.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      rel="nofollow"
                      className="text-sm text-secondary-300 transition-colors hover:text-accent-400"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 rounded-lg border border-secondary-800 bg-secondary-900/60 p-4 md:p-5">
          <p className="flex items-start gap-2 text-xs leading-relaxed text-secondary-300">
            <i className="ri-shield-check-line mt-0.5 text-base text-accent-400" />
            {disclaimerText}
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-secondary-800 pt-6 text-xs text-secondary-400 sm:flex-row sm:items-center sm:justify-between">
          <span>© 2026 黑料曝光网 · 内容演示站点</span>
          <span className="flex flex-wrap items-center gap-4">
            <a href="#top" rel="nofollow" className="hover:text-accent-400">
              免责声明
            </a>
            <a href="#top" rel="nofollow" className="hover:text-accent-400">
              隐私保护
            </a>
            <span>仅供学习演示 · 不对应真实事件</span>
          </span>
        </div>
      </div>
    </footer>
  );
}